import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./Modal.module.css";
import deleteAccount from "../../public/images/deleteAccount.png";

const Modal = ({
  isOpen,
  onRequestClose,
  title,
  description,
  steps = [],
  onYes,
  onNo,
  yesLabel = "Yes, Cancel Account",
  noLabel = "No, Thanks!",
  showIcon = true,
}) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onRequestClose?.();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onRequestClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={onRequestClose}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
      >
        {showIcon && (
          <div className={styles.iconWrapper}>
            <img src={deleteAccount} alt="Delete Account" className={styles.imageIcon} />
          </div>
        )}

        {title && <h3 className={styles.modalTitle}>{title}</h3>}
        {description && <p className={styles.modalDescription}>{description}</p>}

        {steps?.length > 0 && (
          <div className={styles.steps}>
            {steps.map((s, i) => (
              <p key={i}>
                {i + 1}. {s}
              </p>
            ))}
          </div>
        )}

        <div className={styles.actionButtons}>
            {onYes && (
              <button className={styles.noButton} onClick={onYes}>
                {yesLabel}
              </button>
            )}
          {onNo && (
            <button className={styles.yesButton} onClick={onNo}>
              {noLabel}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
